export default __webpack_public_path__ + "static/media/icon-ladderclimb.2fe0a100.svg";